"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgCode = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextItem_1 = require("../../ContextItem");
const CopyCode_1 = require("../../../../1-inline/CopyCode");
const TextBlock_1 = require("../../../../5-block/TextBlock");
const MiniTitle_1 = require("../../../../3-list-item/MiniTitle");
const OptionalBadge_1 = require("./OptionalBadge");
const css_1 = require("./css");
/** Read-only code/ID display with copy-to-clipboard button. */
const ArgCode = ({ param, compact }) => {
    const [t] = (0, use_t_1.useT)();
    const label = param.display?.() ?? t(param.name ?? param.id ?? '');
    if (param.variant === 'block' && !compact) {
        return (React.createElement("div", { className: css_1.argBlockCss, style: { minWidth: 0 } },
            React.createElement("div", { style: { padding: '0 0 4px' } },
                React.createElement(MiniTitle_1.MiniTitle, { literal: true }, label)),
            React.createElement(TextBlock_1.TextBlock, { src: param.value, select: true })));
    }
    const truncate = param.truncate ?? true;
    const isCode = param.variant === 'block';
    return (React.createElement(ContextItem_1.ContextItem, { icon: param.icon?.(), control: true, inset: true, style: { paddingTop: 6, paddingBottom: 6 }, right: React.createElement("span", { style: {
                display: 'flex',
                flex: '1 1 0',
                minWidth: 0,
                maxWidth: 240,
                justifyContent: 'flex-end',
                alignItems: 'center',
                overflow: 'hidden',
                margin: '-5px -8px -5px 0',
            } },
            React.createElement(CopyCode_1.CopyCode, { size: -1, alt: true, roundest: true, noBg: !isCode, value: param.value, truncate: truncate })) },
        React.createElement("span", null,
            label,
            param.optional && React.createElement(OptionalBadge_1.OptionalBadge, null))));
};
exports.ArgCode = ArgCode;
